import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ListItemTestResult from "../common/ListItemTestResult";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import useCurrentConcept from "../hooks/useCurrentConcept";
import {TemplateContext} from "../common/TemplateContext";
import {ContentContext} from "../common/ContentContext";

const StudentActiveLessonsWidget = props => {
    const {className} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {singlePage} = useContext(TemplateContext);
    const {content} = useContext(ContentContext);
    const {loadCurrentConcept} = useCurrentConcept();
    const [enabledConcepts, setEnabledConcepts] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const loadEnabledConcepts = () => {
        setLoading(true);
        axios.get('/web/ui/content/user/enabledConcepts')
            .then(response => {
                setEnabledConcepts(response.data);
                setLoading(false);
            });
    };

    useEffect(() => {
        if(user !== undefined && user.student && brandConfig.disableConcepts) {
            loadEnabledConcepts();
        } else {
            setLoading(false);
        }
    }, [user, content]);

    const handleSelectConcept = (conceptId) => {
        if (conceptId) {
            if (singlePage) {
                loadCurrentConcept(conceptId);
            } else {
                window.location.href = '/controlCentre/navigateSyllabuses.action?conceptId=' + enabledConcept.conceptId;
            }
        }
    }

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-blk-title-main">
                    <span>Active {brandConfig.conceptsName}</span>
                </div>
            }
            className={className}
            isLoading={isLoading}>
            <div className={'ch-dashboard-blk-body'}>
                {enabledConcepts.length > 0 &&
                    <div style={{marginTop: '5px'}}>
                        {enabledConcepts.map((enabledConcept, index) => (
                            <div key={enabledConcept.conceptId} className="ch-dashboard-lesson-link">
                                {enabledConcept.syllabusName}<span className="material-icons">chevron_right</span>{enabledConcept.topicName}<span className="material-icons">chevron_right</span><span className="ch-shortcut-link ch-highlight" onClick={() => {handleSelectConcept(enabledConcept.conceptId)}}>{enabledConcept.conceptName}</span>
                            </div>
                        ))}
                    </div>
                }
                {enabledConcepts.length == 0 &&
                    <div className="ch-list-item-disabled">No active {brandConfig.conceptsName}</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default StudentActiveLessonsWidget;